import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  SegmentCreateEditStateType,
  SetSegmentDetailPayloadActionType,
  OptionType,
} from 'features/Segmentation/@types/SegmentCreateEdit'

export const SLICE_NAME = 'segmentation/segmentCreateEdit'

const initialState: SegmentCreateEditStateType = {
  isLoading: false,
  detail: null,
  profileOptions: [],
  brandOptions: [],
  categoryL1Options: [],
  categoryL2Options: [],
  productOptions: [],
  isResolvingSelectedProducts: false,
}

const segmentCreateEditSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,

    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setSegmentDetail: (state, action: PayloadAction<SetSegmentDetailPayloadActionType>) => {
      state.detail = action.payload
    },
    setProfileOptions: (state, action: PayloadAction<OptionType[]>) => {
      state.profileOptions = action.payload
    },
    setBrandOptions: (state, action: PayloadAction<OptionType[]>) => {
      state.brandOptions = action.payload
    },
    setCategoryL1Options: (state, action: PayloadAction<OptionType[]>) => {
      state.categoryL1Options = action.payload
    },
    setCategoryL2Options: (state, action: PayloadAction<OptionType[]>) => {
      state.categoryL2Options = action.payload
    },
    setProductOptions: (state, action: PayloadAction<OptionType[]>) => {
      state.productOptions = action.payload
    },
    setIsResolvingSelectedProducts: (state, action: PayloadAction<boolean>) => {
      state.isResolvingSelectedProducts = action.payload
    },
  },
})

export const {
  setIsLoading,
  reset,
  setSegmentDetail,
  setProfileOptions,
  setBrandOptions,
  setCategoryL1Options,
  setCategoryL2Options,
  setProductOptions,
  setIsResolvingSelectedProducts,
} = segmentCreateEditSlice.actions
export default segmentCreateEditSlice.reducer
